module.exports = __webpack_public_path__ + "static/media/vessel_onmove.f741e322.svg";